let scriptPromise = null;

function loadScript(siteKey) {
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    if (window.grecaptcha && window.grecaptcha.execute) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(siteKey);
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.head.appendChild(script);
  });

  return scriptPromise;
}

export default function useRecaptcha(siteKey) {

  return function getToken(action = 'submit') {
    if (!siteKey) return Promise.resolve('');

    return loadScript(siteKey)
      .then(() => new Promise((resolve) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(siteKey, { action })
            .then(resolve)
            .catch(() => resolve(''));
        });
      }))
      .catch(() => '');
  };
}
